import { FC } from 'react'

import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { campaignsList, scheduleCampaign } from 'src/Router/routes'
import { CampaignStatusEnum } from 'src/Types/campaigns'
import { ScheduleSteps } from 'src/Types/ui'

import { CreateNewCampaignHelmet } from '../../Components/CreateNewCampaignHelmet'
import { CreateCampaignBreadcrumbsAuth } from '../../Components/CreateCampaignBreadcrumbsAuth'
import { SearchArtistSection } from '../../Components/SearchArtistSection'

import { SuccessCreatedPreReleaseCampaign } from './SuccessCreatedPreReleaseCampaign'
import { usePreReleaseTrackDetails } from './usePreReleaseTrackDetails'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  max-width: 960px;
`

export const PreReleaseTrackDetailsAuth: FC = () => {
  const navigate = useNavigate()
  const { createdCampaign, ...sectionProps } = usePreReleaseTrackDetails()

  const onContinue = (): void => {
    if (createdCampaign?.status === CampaignStatusEnum.APPROVED) {
      navigate(
        `${campaignsList}${scheduleCampaign}/${createdCampaign.id}?step=${ScheduleSteps.SETTINGS}`,
      )
      return
    }

    navigate(campaignsList)
  }

  return (
    <>
      <CreateNewCampaignHelmet />
      <Container>
        <CreateCampaignBreadcrumbsAuth />
        <SearchArtistSection {...sectionProps} />
      </Container>

      {Boolean(createdCampaign) && (
        <SuccessCreatedPreReleaseCampaign onContinue={onContinue} />
      )}
    </>
  )
}
